import { useTranslation } from "react-i18next";
import FormSection from "../../../../common/components/functional/formSection/FormSection";
import LabelSelectRow from "./LabelSelectRow";
import {INVOICE_LANGUAGE_OPTIONS} from "../constants";
import { Typography } from "@mui/material";

export const InvoiceLanguageSection = () => {
  const { t } = useTranslation("customers");
  return (
    <FormSection title={t("contract.invoiceLanguage")}>
      <Typography variant="secondary" padding="1rem">
        {t("contract.invoiceLanguageGuideText")}
      </Typography>
      <LabelSelectRow
        label={t("contract.invoiceLanguage")}
        fieldName="invoiceLanguage"
        options={INVOICE_LANGUAGE_OPTIONS}
        getDisplayValue={(val) => (val ? t(`common:${val.toLowerCase()}`) : "")}
        selectWidth={2}
      />
    </FormSection>
  );
};
